export const getPropertyAnnotations = state => state.propertyAnnotations.propertyHintsOn;